import { Reducer } from 'redux';
import {
    initialMyPortfolioCapsulesDataState,
    MyPortfolioCapsulesDataState,
} from './MyPortfolioCapsulesDataState';
import {
    MyPortfolioCapsulesDataAction,
    MyPortfolioCapsulesDataActionType,
} from './actions';

export const myPortfolioCapsulesDataReducer: Reducer<
    MyPortfolioCapsulesDataState,
    MyPortfolioCapsulesDataAction
> = (state = initialMyPortfolioCapsulesDataState(), action) => {
    switch (action.type) {
        case MyPortfolioCapsulesDataActionType.SET: {
            return action.payload!;
        }
        case MyPortfolioCapsulesDataActionType.CLEAR: {
            return initialMyPortfolioCapsulesDataState();
        }
    }
    return state;
};
